module.exports = __webpack_public_path__ + "img/test.1fc032eb.png";